import { formatCnpj, onlyDigits, ufFromAbbreviation } from '@functions/brazil-documents';
import { CnpjLookupResponse } from '@services/cnpj-lookup.service';
import { onlyDigits as phoneDigits } from '@layouts/pages/CRM/kanban-board/formatters/crm-phone-mask';
import { AddressFormValues, addressFromForm } from '@layouts/pages/CRM/people/address-form';
import { CompanyRequest } from './services/requests/company.request';
import { CompanyOptionResponse } from './services/responses/company.response';

export interface CompanyFormValues extends AddressFormValues {
    name: string;
    tradeName?: string;
    cnpj?: string;
    phone?: string;
    email?: string;
    notes?: string;
}

/// Duas empresas de mesmo nome só se distinguem pelo CNPJ, então ele vai no rótulo.
export const companyOptionLabel = (company: CompanyOptionResponse): string =>
    company.cnpj ? `${company.name} · ${formatCnpj(company.cnpj)}` : company.name;

export const toCompanyRequest = (data: CompanyFormValues): CompanyRequest => ({
    name: data.name.trim(),
    tradeName: data.tradeName?.trim() || undefined,
    cnpj: onlyDigits(data.cnpj) || undefined,
    phone: phoneDigits(data.phone ?? '') || undefined,
    email: data.email?.trim() || undefined,
    notes: data.notes?.trim() || undefined,
    address: addressFromForm(data),
});

/// O que a consulta do CNPJ preenche: razão social sempre da Receita; o resto só onde está vazio.
export const cnpjLookupFields = (
    data: CnpjLookupResponse,
    current: Pick<CompanyFormValues, 'tradeName' | 'postalCode'>,
): Partial<CompanyFormValues> => {
    const fields: Partial<CompanyFormValues> = { name: data.razao_social ?? '' };

    if (!current.tradeName && data.nome_fantasia) fields.tradeName = data.nome_fantasia;

    if (!current.postalCode && data.cep) {
        fields.postalCode = onlyDigits(data.cep);
        fields.streetName = data.logradouro ?? '';
        fields.number = data.numero ?? '';
        fields.complement = data.complemento ?? '';
        fields.district = data.bairro ?? '';
        fields.city = data.municipio ?? '';
        fields.state = String(ufFromAbbreviation(data.uf) ?? '');
    }

    return fields;
};

/// Empresa baixada ou inapta é informação de venda, não erro: grava e avisa.
export const inactiveRegistration = (data: CnpjLookupResponse): string | null => {
    const status = (data.descricao_situacao_cadastral ?? '').toUpperCase();

    return status && status !== 'ATIVA' ? status : null;
};
